export default __webpack_public_path__ + "static/media/automate.87227700.png";